import { Combobox as ComboboxUI, Input, InputBase, useCombobox } from '@mantine/core';
import { Wrapper } from './Combobox.style';

export type ComboboxProps = {
  value: string | null;
  options: IOption[];
  onChange: (value: string) => void;
  placeholder: string;
};

export function Combobox(props: ComboboxProps) {
  const { value, options, placeholder } = props;
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const items = options.map((option) => (
    <ComboboxUI.Option value={option.id} key={option.id}>
      {option.text}
    </ComboboxUI.Option>
  ));

  const text = options.find((option) => option.id === value)?.text;

  return (
    <Wrapper className='Combobox-wrapper' data-testid='Combobox-wrapper'>
      <ComboboxUI
        store={combobox}
        onOptionSubmit={(val) => {
          props.onChange(val);
          combobox.closeDropdown();
        }}
      >
        <ComboboxUI.Target>
          <InputBase
            component='button'
            type='button'
            pointer
            rightSection={<ComboboxUI.Chevron />}
            rightSectionPointerEvents='none'
            onClick={() => combobox.toggleDropdown()}
          >
            {text || <Input.Placeholder>{placeholder}</Input.Placeholder>}
          </InputBase>
        </ComboboxUI.Target>

        <ComboboxUI.Dropdown>
          <ComboboxUI.Options>{items}</ComboboxUI.Options>
        </ComboboxUI.Dropdown>
      </ComboboxUI>
    </Wrapper>
  );
}

export default Combobox;
